import axios from 'axios';

export async function VerifyResetPasswordApi(token) {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVICE}/backend-service/v1/reset-password/${token}`, { withCredentials: true})
    return response;
  } catch (error) {
    return error.response;
  }
}

